module.exports = {"621123100":"清源镇","621123101":"莲峰镇","621123102":"会川镇","621123103":"五竹镇","621123104":"路园镇","621123105":"北寨镇","621123106":"新寨镇","621123107":"麻家集镇","621123200":"锹峪乡","621123203":"大安乡","621123204":"秦祁乡","621123206":"庆坪乡","621123207":"祁家庙乡","621123208":"上湾乡","621123209":"峡城乡","621123210":"田家河乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/621123.json
// module id = 2737
// module chunks = 0